export enum AdminRoleType {
    None = 0,
    TARAdmin = 1,
    TARHRAdmin = 2,
    TARBenefitsAdmin = 3,
    TARRetailAdmin = 4
}

export const UntrackedUserErrorMsg = 'Currently user is not tracked in TAR';
